import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyAiRecommendationsFeedback = loadable(
  () =>
    import(
      /* webpackChunkName: "content/admin/travel-map/ai-recommendations-feedback" */
      './AiRecommendationsFeedback'
    ),
);
